<template>
  <div class="p-1" aria-labelledby="basket-summary-title">
    <div v-if="basketItems && basketItems.length">
      <div class="basket-list">
        <!-- Render basket items -->
        <div v-for="product in basketItems" :key="product.id">
          <BasketProduct
            :product="product"
            :max="productMaxMap[product.id]"
            @product-quantity-change="onProductQuantityChange"
          />
        </div>
      </div>
    </div>
    <Button class="btn btn-accordion" variant="secondary" @click="close">
      <span>{{ $t('system.button.close') }}</span>
    </Button>
  </div>
</template>

<script>
import BasketProduct from "@/components/sub-components/Basket/BasketProduct.vue";
import Button from "@/components/actions/Button.vue";
import { getGroupMaxAvailable } from '@/utils/mealPlanUtils';

export default {
  components: {
    Button,
    BasketProduct,
  },
  props: {
    basketItems: {
      type: Array,
      required: false,
      default: () => []
    },
    mealPlanGroups: {
      type: Array,
      required: false,
      default: () => []
    },
    productMaxMap: {
      type: Object,
      required: false,
      default: () => ({})
    }
  },
  methods: {
    close() {
      this.$emit('close');
    },
    getGroupId(product) {
      if (product.extendedInfos) {
        try {
          const ext = typeof product.extendedInfos === 'string' ? JSON.parse(product.extendedInfos) : product.extendedInfos;
          return ext?.mealPlan?.groupId || product.groupId;
        } catch {
          return product.groupId;
        }
      }
      return product.groupId;
    },
    getMaxAvailableForProduct(groupId, productId) {
      return getGroupMaxAvailable(
        groupId,
        productId,
        this.basketItems,
        this.mealPlanGroups
      );
    },
    onProductQuantityChange(basketId, quantity) {
      this.$emit('product-quantity-change', basketId, quantity);
      // If there is only 1 basketItem and quantity is 0, close the editor automatically
      if (this.basketItems.length === 1 && quantity === 0) {
        this.close();
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/css/customizer';

.basket-container {
  margin: 0 auto;
  padding: 0 10px;
  width: 100%;
}

.basket-title {
  font-size: 20px;
  display: flex;
  justify-content: space-between; /* Space between the two spans */
  align-items: center; /* Center the text vertically */
  width: 100%; /* Ensure it takes the full width */
}

.basket-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.basket-total {
  display: flex;
  justify-content: space-between;
  font-weight: bold;
  padding: 12px 0;
  border-top: 1px solid #ccc;
  margin-top: 12px;
}

.basket-total.no-vat {
  border-top: none;
  margin-top: 0;
}

.total-price {
  color: #0057b8;
}

.basket-vats {
  margin-top: 12px;
  font-size: 16px;
}

.vat-row,
.vat-total {
  display: flex;
  justify-content: space-between;
  padding: 4px 0;
}

.empty-basket {
  text-align: center;
  padding: 20px;
  color: #666;
}
</style>

